import * as React from 'react';
import { useMemo } from 'react';

import map from 'lodash/map';
import uniqueId from 'lodash/uniqueId';

import {
  Button,
  CustomBadge,
  GridLegacy,
  Select,
  SelectOption,
  Stack,
  Typography,
  useTransformSelectValue,
} from '@sbv-clients/ui-shared';

import {
  GetAdminFacilitiesGetData,
  useAdminFacilitiesGet,
} from '../../services/admin';

export interface FilterHeaderPropsType {
  facilityId: string | 'All';
  setFacilityId: (facility: string | 'All') => void;
  isNew?: boolean | null;
}

interface FacilitySelectProps {
  facility: string | 'All';
  setFacility: (facility: string | 'All') => void;
  data: GetAdminFacilitiesGetData;
}

function FacilitySelect({ facility, setFacility, data }: FacilitySelectProps) {
  const options: SelectOption<unknown>[] = useMemo(() => {
    const o = map(data?.facilities, (item) => {
      const id = item.id || uniqueId();
      return {
        id,
        label: item.facilityName ?? '',
        value: id,
      };
    });
    o.unshift({ id: 'All', label: 'All facilities', value: 'All' });
    return o;
  }, [data]);

  const handleChange = useTransformSelectValue(setFacility);

  return (
    <Select
      fullWidth
      size="small"
      value={facility}
      label="Facility"
      options={options}
      onChange={handleChange}
    />
  );
}

export function FilterHeader({
  facilityId,
  setFacilityId,
  isNew,
}: FilterHeaderPropsType) {
  const { data } = useAdminFacilitiesGet({});

  return (
    <GridLegacy container justifyContent={'space-between'}>
      <GridLegacy item>
        <Stack direction={'row'} spacing={2} alignItems={'center'}>
          <Typography variant={'h3'}>Database Stats</Typography>
          {isNew && <CustomBadge type={'info'}>New</CustomBadge>}
        </Stack>
      </GridLegacy>
      <GridLegacy
        xs={7}
        lg={5}
        xl={4}
        item
        container
        spacing={3}
        justifyContent={'flex-end'}
      >
        <GridLegacy item xs>
          <FacilitySelect
            data={data}
            facility={facilityId}
            setFacility={setFacilityId}
          />
        </GridLegacy>
        <GridLegacy item xs={'auto'}>
          <Button variant={'outlined'} disabled size={'small'}>
            Export
          </Button>
        </GridLegacy>
      </GridLegacy>
    </GridLegacy>
  );
}
